import { render, staticRenderFns } from "./GastroVisitaProctologicaEditComponent.vue?vue&type=template&id=4636d16a"
import script from "./GastroVisitaProctologicaEditComponent.vue?vue&type=script&lang=js"
export * from "./GastroVisitaProctologicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports